export const NORMAL_CUSTOMER_TYPE_VALUE = '5'

export const JURISTIC_CUSTOMER_TYPE_VALUE = '2'

export const HEADQUARTER_BRANCH_NUMBER = '00000'
